import { Component, OnInit, OnDestroy } from '@angular/core';
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner';
import { AlertController, Platform, ModalController, NavController, NavParams, App, ToastController } from 'ionic-angular';
import { MyEventsProvider } from '../../providers/my-events/my-events';
import { ToastHelper } from '../../helpers/toastr-helper';

/**
 * Generated class for the QrCodeReaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'qr-code-reader',
  templateUrl: 'qr-code-reader.html'
})
export class QrCodeReaderComponent implements OnInit, OnDestroy {

  scanSub: any;

  constructor(
    private qrScanner: QRScanner,
    private alertCtrl: AlertController,
    private platform: Platform,
    private modalCtrl: ModalController,
    public navCtrl: NavController, public navParams: NavParams,
    private myEventsProvider: MyEventsProvider,
    private app: App,
    private toastCtrl: ToastController
  ) {}

  ngOnInit() {
    if (this.platform.is('cordova')) {
      this.scan();
      this.showCamera();
    }
  }

  ngOnDestroy() {
    this.hideCamera();
    if (this.platform.is('cordova')) {
      this.qrScanner.hide(); // hide camera preview
      this.scanSub.unsubscribe(); // stop scanning
    }
  }

  scan() {
    // Optionally request the permission early
    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // camera permission was granted

          this.startScan();

          this.qrScanner.resumePreview().then();

          // show camera preview
          this.qrScanner.show().then();
        } else if (status.denied) {
          // camera permission was permanently denied
          // you must use QRScanner.openSettings() method to guide the user to the settings page
          // then they can grant the permission from there
        } else {
          // permission was denied, but not permanently. You can ask for permission again at a later time.
        }
      })
      .catch((e: any) => this.scan());
  }

  startScan() {
    // start scanning
    this.scanSub = this.qrScanner.scan().subscribe((text: string) => {
      const qr = text.split(':');
      if (qr[0] === 'VirtualBooth') {
        const eventUuid = qr[1];
        const eventPin = qr[2];
        const eventName = qr[3];
        this.presentConfirm(eventUuid, eventPin, eventName);
      }
      // this.qrScanner.hide(); // hide camera preview
      this.scanSub.unsubscribe(); // stop scanning
    });
  }

  showCamera() {
    (window.document.querySelector("ion-app") as HTMLElement).classList.add(
      "cameraView"
    );
  }

  hideCamera() {
    (window.document.querySelector("ion-app") as HTMLElement).classList.remove(
      "cameraView"
    );
  }

  presentConfirm(eventUuid: string, eventPin: string, eventName: string) {
    let alert = this.alertCtrl.create({
      title: eventName,
      message: '',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.startScan();
          }
        },
        {
          text: 'Go to booth',
          handler: () => {
            this.openItem(eventUuid, eventPin, eventName)
            this.startScan();
          }
        }
      ]
    });
    alert.present();
  }

  openItem(eventUuid: string, eventPin: string, eventName: string) {
    this.myEventsProvider.joinEvent(eventUuid).subscribe(
        res => {
            this.app.getRootNav().setRoot('EventSwitchPage', {
                pin: eventPin,
                name: eventName
            });
        },
        err => {
          if (err.status === 409) {
            ToastHelper.Show(this.toastCtrl, err.error.message, 2000)
          }
        }
    );
  }


}



// WEBPACK FOOTER //
// ./src/components/qr-code-reader/qr-code-reader.ts